// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';

import { requestEmailVerification } from '../../api/selfServiceServices';
import type { EmailVerificationResponse } from '../../api/types';

const useRequestEmailVerification = () => {
  return useMutation<EmailVerificationResponse, Error, void>({
    mutationFn: () => requestEmailVerification(),
  });
};

export default useRequestEmailVerification;
